module.exports = __webpack_public_path__ + "img/shanghai.b7268181.png";